import { IFilter } from 'shared/types/filter.interface';

/** Purchases is the UI's narrow Redeemed filter; the Redeemed umbrella also includes Shared. */
export function transactionTypeFilters(filters: IFilter[]): IFilter[] {
  const result: IFilter[] = [];
  const statuses = new Set<string>();
  let includeShared = false;
  for (const filter of filters) {
    if (filter.name !== 'status') {
      result.push({ ...filter });
      continue;
    }
    for (const value of filter.value.split(',')) {
      const status = value === 'Purchases' ? 'Redeemed' : value;
      if (!statuses.has(status)) {
        statuses.add(status);
        result.push({ name: 'status', value: status });
      }
      if (value === 'Redeemed') includeShared = true;
    }
  }
  if (includeShared && !statuses.has('Shared')) result.push({ name: 'status', value: 'Shared' });
  return result;
}
